<template>
  <div class="wrapper">
    <div class="content-container">
      <div class="stingy-card">
      <div class="economics-card">
        <h2>📊 MacroMeow's Economics Perch 📊</h2>

        <img src="https://assets.codepen.io/11151897/macromeowcnbc.png" alt="MacroMeow" class="cat-image" />
        <p>
          Greetings, astute observers of the economic catwalk! I'm MacroMeow, your guide to the fascinating world of interest rates, the ebb and flow of macroeconomic trends, and the ever-prowling inflation. Let's curl up and make sense of these numbers, shall we?
        </p>
        <p>
          🏦 <strong>Interest Rates:</strong> These are the yarn balls of the economy – they keep things rolling. When rates climb, it's like a cat stretching up – saving gets more rewarding, but borrowing becomes a tall order. When they dip, it's crouching time, making it easier to pounce on loans.
        </p>
        <p>
          🌍 <strong>Macroeconomic Trends:</strong> Keep a feline eye on these! They're the purring engine behind job markets, trade, and overall economic health. Whether the economy's leaping or napping, these trends affect your kitty kibble stockpile.
        </p>
        <p>
          📈 <strong>Inflation:</strong> The silent sneak that can make your cash stash less bountiful. Inflation is like a growing kitten – cute at first, but if it gets too big, it can eat into your buying power faster than a cat with catnip!  As a curious cat I believe the actual basket of goods used to come up with the actual inflation number, which does not include rent, is skewed so be skeptical and ensure you're working your own money as hard as possible. 
        </p>
        <p>
          Now, let's check the economic forecast with our crystal ball and see where the winds blow in the land of economics.
        </p>
  <div class="finlogix-container" ref="finlogixContainer"></div></div></div></div></div><br><br><br><br><br>
  
  
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  setup() {
    const finlogixContainer = ref(null);

    onMounted(() => {
      // Load the Finlogix Widget script
      const finlogixScript = document.createElement('script');
      finlogixScript.src = 'https://widget.finlogix.com/Widget.js';
      finlogixScript.async = true;
      document.body.appendChild(finlogixScript);

      // Initialize the widget once the script is loaded
      finlogixScript.onload = () => {
        const initScript = document.createElement('script');
        initScript.type = 'text/javascript';
        initScript.innerHTML = `
          Widget.init({
            widgetId: "400137d3-9248-45fd-a1c2-d46eb06b52f0",
            type: "EconomicCalendar",
            language: "en",
            isAdaptive: true
          });
        `;
        finlogixContainer.value.appendChild(initScript);
      };
    });

    return {
      finlogixContainer
    };
  }
};
</script>

<style scoped>

.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}

.cat-image {
  max-width: 100%;
  height: auto;
  display: block; /* Ensures the image is centered if its width is less than the container's width */
  margin: 0 auto; /* Center align the image */
}

@media (max-width: 768px) { /* Adjustments for tablets */
  .cat-image {
    max-width: 80%; /* Example: you might want the image to take up less space on tablets */
  }
}

@media (max-width: 480px) { /* Adjustments for mobile phones */
  .cat-image {
    max-width: 100%; /* On smaller screens, the image can take up more of the width */
  }
}
</style>
